import MonetaryAmount from '../MonetaryAmount';

class ItemGroup {
  groupId: string;

  groupDisplayName: string;

  itemGroupTotalLabel: string;

  grossDiscountedCents: MonetaryAmount;

  netDiscountedCents: MonetaryAmount;

  grossListCents: MonetaryAmount;

  netListCents: MonetaryAmount;

  lineItemIds: string[];

  customOrderData: object;

  constructor() {
    this.groupId = '';
    this.groupDisplayName = '';
    this.itemGroupTotalLabel = '';
    this.grossDiscountedCents = new MonetaryAmount();
    this.netDiscountedCents = new MonetaryAmount();
    this.grossListCents = new MonetaryAmount();
    this.netListCents = new MonetaryAmount();
    this.lineItemIds = [];
    this.customOrderData = {};
  }
}

export default ItemGroup;
